function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var NonBufferedString = /*#__PURE__*/function () {
  function NonBufferedString() {
    _classCallCheck(this, NonBufferedString);

    this.decoder = new TextDecoder("utf-8");
    this.strings = [];
    this.byteLength = 0;
  }

  _createClass(NonBufferedString, [{
    key: "appendChar",
    value: function appendChar(char) {
      this.strings.push(String.fromCharCode(char));
      this.byteLength += 1;
    }
  }, {
    key: "appendBuf",
    value: function appendBuf(buf) {
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : buf.length;
      this.strings.push(this.decoder.decode(buf.subarray(start, end)));
      this.byteLength += end - start;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.strings = [];
      this.byteLength = 0;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.strings.join("");
    }
  }]);

  return NonBufferedString;
}();
export var BufferedString = /*#__PURE__*/function () {
  function BufferedString(bufferSize) {
    _classCallCheck(this, BufferedString);

    this.decoder = new TextDecoder("utf-8");
    this.bufferOffset = 0;
    this.string = "";
    this.byteLength = 0;
    this.buffer = new Uint8Array(bufferSize);
  }

  _createClass(BufferedString, [{
    key: "appendChar",
    value: function appendChar(char) {
      if (this.bufferOffset >= this.buffer.length) this.flushStringBuffer();
      this.buffer[this.bufferOffset++] = char;
      this.byteLength += 1;
    }
  }, {
    key: "appendBuf",
    value: function appendBuf(buf) {
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : buf.length;
      var size = end - start;
      if (this.bufferOffset + size > this.buffer.length) this.flushStringBuffer();
      this.buffer.set(buf.subarray(start, end), this.bufferOffset);
      this.bufferOffset += size;
      this.byteLength += size;
    }
  }, {
    key: "flushStringBuffer",
    value: function flushStringBuffer() {
      this.string += this.decoder.decode(this.buffer.subarray(0, this.bufferOffset));
      this.bufferOffset = 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.string = "";
      this.bufferOffset = 0;
      this.byteLength = 0;
    }
  }, {
    key: "toString",
    value: function toString() {
      this.flushStringBuffer();
      return this.string;
    }
  }]);

  return BufferedString;
}();